<div [formGroup]="monitoringConfig">
    <div class="flex items-center gap-2 my-2">
        <p-checkbox formControlName="defaultMeasurementStarted" inputId="defaultMeasurementStarted" [binary]="true"/>
        <label for="defaultMeasurementStarted" class="text-sm">{{ 'fields.default-measurement-started' | translate }}</label>
    </div>
    <p class="text-sm text-muted-color mb-2">{{ 'projects.monitoringConfig.hint' | translate }}</p>
</div>

<div class="w-full text-center">
    <button pButton (click)="save()">{{ ('button.save') | translate }}</button>
</div>
